import { colors } from '../../../theme/color-palette';
import purpleRectangle from '../../../assets/legends/mediumPurpleRectangle.svg';
import purpleRectangleDashed from '../../../assets/legends/dashedRectangle.svg';
import orangeRectangle from '../../../assets/legends/mediumOrangeRectangle.svg';
import orangeRectangleDashed from '../../../assets/legends/dashedOrangeRectangle.svg';
import { opd } from './constants';

export const getToolTipFormat = (
	primaryOptionObject,
	compareOptionObject,
	numberFormat,
	numberFormatCompare,
	timePeriod
) => {
	const isCompareMode = compareOptionObject !== null;
	const thisYearLabelPrimary = isCompareMode
		? `${primaryOptionObject?.label} this year`
		: 'This year';
	const lastYearLabelPrimary = isCompareMode
		? `${primaryOptionObject?.label} last year`
		: 'Last year';

	const thisYearLabelCompare = isCompareMode
		? `${compareOptionObject?.label} this year`
		: 'This year';
	const lastYearLabelCompare = isCompareMode
		? `${compareOptionObject?.label} last year`
		: 'Last year';

	const header = isCompareMode
		? ``
		: `<div style="
                font-size: 12px;
                width: 280px;
                text-align: left;
                font-family: 'Bogle-Regular';
                font-weight: 700; 
                line-height: 16px;
                color: ${colors.FONT_COLOR}">
                ${primaryOptionObject.label}
            </div>`;

	return `<div style="padding: 16px; border-radius: 8px; display: flex; flex-direction: column; gap: 12px;   ">

        <div style="display: flex; flex-direction: column; gap: 4px; justify-content: flex-start">
            
    ${header}
            <div style="font-family: Bogle;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
                color: ${colors.LIGHT_GRAY_HEX};
                display: flex;">
                {${
									timePeriod === 'Daily'
										? 'daily'
										: timePeriod === 'Weekly'
										? 'weekly'
										: 'monthly'
								}}
            </div>
        </div>

        <div style="display: flex; flex-direction: column; gap: 12px; justify-content: flex-start">

        <div style="display: flex; gap: 8px">
                <div>
                    <img style="height: 6px; width: 10px; " src =${purpleRectangle} />
                </div>
                <div style="display: flex; gap: 8px; color: ${
									colors.FONT_COLOR
								}">
                    <div style="display: flex; ">
                        ${thisYearLabelPrimary}
                    </div>
                    <div style="font-weight: 700">
                        {tyValue.formatNumber("${numberFormat}")}
                    </div>
                </div>

                
${
	!(
		primaryOptionObject?.label.includes('YoY % Change') ||
		opd?.includes(primaryOptionObject?.id)
	) &&
	`
						


               <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%" >
                    <div style="display: flex; flex-direction: column; gap: 4px; align-items: flex-start">
                        <div style="display: flex; font-size: 12px; line-height: 16px; color: ${colors.FONT_COLOR}">
                            <span style= "
                                background-color:{bpsChgRefBackgroundColor}; 
                                padding: 0px 4px 0px 4px; 
                                border-radius: 5px; 
                                font-size: 12px; 
                                color: {bpsChgRefColor};
                                font-weight: 700;
                                display: flex;
                                flex-direction: row;
                                gap: 2px;
                                line-height: 16px;
                                align-items: center;"> 
                                    <img style="padding: 2px 4px; height: 12px; width: 8px; " src={bpsChgRefArrow} />  
                                    {yoy_abs} %
                            </span>
                            <span style="font-size: 12px; margin-left: 5px; color: ${colors.FONT_COLOR}">vs Last year</span>
                        </div>
                    </div>
                </div>
            </div>    


            <div style="display: flex; gap: 8px">
                <div>
                   <img style="height: 10px; width: 6px; margin-left: 2px; " src =${purpleRectangleDashed} />
                </div>
                <div style="display: flex; gap: 8px; color: ${colors.FONT_COLOR}">
                    <div style="display: flex; ">
                        ${lastYearLabelPrimary}
                    </div>
                    <div style="font-weight: 700">
                        {lyValue.formatNumber("${numberFormat}")}
                    </div>
                </div>
                `
}
            </div> 

            
            ${
							isCompareMode
								? `<hr style="width: 100%; border: none; background-color: #E3E4E5; color: #E3E4E5; height: 1px;">

                      <div style="display: flex; gap: 8px; align-items: center">
                <div>
                    <img style="height: 6px; width: 10px; " src =${orangeRectangle} />

                </div>
                <div style="display: flex; gap: 8px; color: ${
									colors.FONT_COLOR
								}">
                    <div style="display: flex; ">
                        ${thisYearLabelCompare}
                    </div>
                    <div style="font-weight: 700">
                        {tyValueCompare.formatNumber("${numberFormatCompare}")}
                    </div>
                </div>

                ${
									!(
										compareOptionObject?.label.includes('YoY % Change') ||
										opd?.includes(compareOptionObject?.id)
									) &&
									`
						<div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%" >
                    <div style="display: flex; flex-direction: column; gap: 4px; align-items: flex-start">
                        <div style="display: flex; font-size: 12px; line-height: 16px; color: ${colors.FONT_COLOR}">
                            <span style= "
                                background-color:{bpsChgRefBackgroundColorCompare}; 
                                padding: 0px 4px 0px 4px; 
                                border-radius: 5px; 
                                font-size: 12px; 
                                color: {bpsChgRefColorCompare};
                                font-weight: 700;
                                display: flex;
                                flex-direction: row;
                                gap: 2px;
                                line-height: 16px;
                                align-items: center;"> 
                                    <img style="padding: 2px 4px; height: 12px; width: 8px; " src={bpsChgRefArrowCompare} />  
                                    {yoyCompare} %
                            </span>
                            <span style="font-size: 12px; margin-left: 5px; color: ${colors.FONT_COLOR}">vs Last year</span>
                        </div>
                    </div>
                </div>
            </div>    


            <div style="display: flex; gap: 8px; align-items: center;">
                <div>
                    <img style="height: 10px; width: 6px; margin-left: 1.5px; fill: orange; " src =${orangeRectangleDashed} />
                </div>
                <div style="display: flex; gap: 8px; color: ${colors.FONT_COLOR}">
                    <div style="display: flex; ">
                        ${lastYearLabelCompare}
                    </div>
                    <div style="font-weight: 700">
                        {lyValueCompare.formatNumber("${numberFormatCompare}")}
                    </div>
                </div>`
								}
            </div> 
        </div>
                                `
								: ''
						}
    </div>`;
};
